



























































































import { Either, Left, Right } from 'fp-ts/lib/Either'
import _ from 'lodash'
import { Validator } from 'vee-validate'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Inject, Prop } from 'vue-property-decorator'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import AddressSearchButton from '@spa/components/organisms/AddressSearchButton.vue'
import PrefectureSelect from '@spa/components/organisms/PrefectureSelectBox.vue'
import { AddressFieldsEnabledState } from '@spa/components/pages/mypage/edit/contact/interaction'
import { PluginMixin } from '@spa/mixins/plugin'
import { AddressFormState, AddressSearchInteraction } from './addressFormState'

@Component({
  components: {
    AddressSearchButton,
    PrefectureSelect,
    SpaErrorDialog,
  },
})
export default class AddressForm extends Mixins<PluginMixin>(PluginMixin) {
  @Inject()
  $validator: Validator

  @Prop({ default: '' })
  zipcode: string

  @Prop({ default: '' })
  prefectureCode: string

  @Prop({ default: '' })
  city: string

  @Prop({ default: '' })
  town: string

  @Prop({ default: '' })
  namePrefix: string

  @Prop({ required: true })
  addressFieldsEnabledState: AddressFieldsEnabledState

  @Prop({ required: true })
  handleFormUpdated: (val: AddressFormState) => void

  @Prop({ default: false })
  isRequired: boolean

  @Prop({ default: true })
  isHeaderVisible: boolean

  showModal: boolean = false

  modalMessage: string = ''

  searchAddressEnabled: boolean = true

  addressAutoSearchedAndFailed: boolean = false

  get formState(): AddressFormState {
    return {
      zipcode: this.zipcode,
      prefectureCode: this.prefectureCode,
      city: this.city,
      town: this.town,
    }
  }

  get hasExtendedValidationError(): boolean {
    return !!this.$slots.extendedValidationErrorMessage
  }

  async onZipcodeChanged(zipcode: string): Promise<void> {
    this.addressAutoSearchedAndFailed = false

    const isZipCodeValid = this.isValidFormatZipcode(zipcode)
    if (isZipCodeValid) {
      const foundAddress = await this.autoSearchAddress(zipcode)
      if (foundAddress.isLeft()) {
        this.addressAutoSearchedAndFailed = true
      }
    }
  }

  isValidFormatZipcode(zipcode: string): boolean {
    const regexZipcode = /^[0-9０-９]{7}$/

    return regexZipcode.test(zipcode)
  }

  async autoSearchAddress(zipCode: string): Promise<Either<Error, null>> {

    this.searchAddressEnabled = false

    return this.searchAddressAndFillForm(zipCode)
      .then(() => new Right<Error, null>(null))
      .catch(error => new Left<Error, null>(error))
      .finally(() => {
        this.searchAddressEnabled = true
      })

  }

  get zipcodeValidation(): any {
    return {
      required: this.isRequired,
      // Consoleで検索しやすくするため、ユーザからの入力としては全角の数字を許容しつつも、バックエンドで半角に変換し名寄せする。
      // https://github.com/my-color/front/issues/2320
      regex: /^[0-9０-９]{7}$/,
    }
  }

  get prefectureCodeValidation(): any {
    return {
      required: this.isRequired,
    }
  }

  get subAddressValidation(): any {
    return {
      required: this.isRequired,
      /**
       * 配送システムの都合
       * @see https://github.com/Everforth/growthpalette-front/issues/8148
       */
      max: 48,
      unusable_character: true,
      contains_tab: true,
    }
  }

  nameWithPrefix(name: string) {
    return !!this.namePrefix ? `${this.namePrefix}-${name}` : name
  }

  async handleInputZipcode(zipCode: string): Promise<void> {
    this.handleFormUpdated({
      ...this.formState,
      zipcode: zipCode,
    })

    await this.onZipcodeChanged(zipCode)
  }

  handleInputPrefectureCode(input: string): void {
    this.handleFormUpdated({
      ...this.formState,
      prefectureCode: input,
    })
  }

  handleInputCity(input: string): void {
    this.handleFormUpdated({
      ...this.formState,
      city: input,
    })
  }

  handleInputTown(input: string): void {
    this.handleFormUpdated({
      ...this.formState,
      town: input,
    })
  }

  async onSearchAddressButtonPressed() {
    const zipcode = this.zipcode

    if (!this.isValidFormatZipcode(zipcode)) {
      this.modalMessage = '郵便番号のフォーマットが正しくありません'
      this.showModal = true

      return
    }

    this.searchAddressEnabled = false

    try {
      await this.searchAddressAndFillForm(zipcode)

    } catch (error) {
      this.modalMessage = '住所が取得できませんでした'
      this.showModal = true
    } finally {
      this.searchAddressEnabled = true
    }
  }

  async searchAddressAndFillForm(zipcode: string): Promise<void> {
    const addressSearchInteraction = new AddressSearchInteraction()
    const addressSearchResult = await addressSearchInteraction.search(zipcode).finally(() => {
      this.$emit('searched-address')
    })

    const prefectureCode = addressSearchResult.prefectureCode
    const city = addressSearchResult.city
    const town = addressSearchResult.town

    this.handleFormUpdated({
      zipcode: this.zipcode,
      prefectureCode,
      city,
      town,
    })

  }
}
